<template>
    <div>
      <div class="rounded-lg text-center">
        <div class="rounded-lg" style="background-color: rgba(63, 81, 181, 0.8); color: white;">
          <h1 class="ml-4 pt-2">Diagnóstico de Hábitos Lectores</h1>
        </div>
      </div>

      <!-- Instrucciones -->
      <v-card flat class="my-4 mx-4 pa-4">
        <v-card-text class="text-center ">
          <h3>Intrucciones: En la siguiente encuesta, necesitamos obtener información acerca de tus hábitos lectores y tu actitud hacia la lectura. No hay respuestas buenas ni malas, solo necesitamos conocer tu opinión sincera sobre los temas que estamos consultando. Por favor, selecciona la opción que más te representa en las siguientes preguntas. ¡Muchas gracias por tu participación!</h3>
        </v-card-text>
      </v-card>

      <v-row v-if="loading" justify="center" align="center" style="height: 80vh">
        <v-col cols="12" class="text-center">
          <v-progress-circular size="80" width="5" color="primary" indeterminate></v-progress-circular>
          <div class="mt-4 text-h6">Cargando...</div>
        </v-col>
      </v-row>
      
      <v-card v-else flat class="mt-4 pa-4 scrollable-content--large">
        <template>
          <v-card v-for="(question, index) in questions"
            :key="'question-'+question.id"
            class="mb-6"
          >
            <v-card-title class="white--text book-paragraph primary">
              <v-icon left color="white">mdi-comment-question</v-icon>
              {{ `Pregunta ${index + 1}: ${question.text}` }}
            </v-card-title>
  
            <v-card-text>
              <!-- Single Choice -->
              <div v-if="question.type === 'single_choice'" class="options-container">
                <v-radio-group disabled>
                  <v-radio
                    v-for="option in question.options"
                    :key="`option-${question.id}-${option.id}`"
                    :value="option.id"
                    color="success"
                    disabled
                  >
                    <template v-slot:label>
                      <span>{{ option.text }}</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
  
              <!-- Multiple Choice -->
              <div v-if="question.type === 'multiple_choice'" class="options-container">
                <medium class="caption" v-if="question.max_selections">
                  Se pueden seleccionar {{ question.max_selections }} opciones
                </medium>
                <v-checkbox
                  v-for="option in question.options"
                  :key="`moption-${question.id}-${option.id}`"
                  :label="option.text"
                  :value="option.id"
                  disabled
                  class="custom-checkbox"
                >
                </v-checkbox>
              </div>
  
              <!-- Matrix -->
              <div v-if="question.type === 'matrix'" class="matrix-container">
                <v-table class="matrix-table">
                  <thead>
                    <tr>
                      <th class="subquestion-header"></th>
                      <th 
                        v-for="option in question.options" 
                        :key="`header-${question.id}-${option.id}`"
                        class="option-header"
                      >
                        {{ option.text }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="sub in question.sub_questions" 
                      :key="`row-${question.id}-${sub.id}`"
                    >
                      <td class="subquestion-cell">{{ sub.text }}</td>
                      <td 
                        v-for="option in question.options" 
                        :key="`cell-${question.id}-${sub.id}-${option.id}`"
                        class="option-cell"
                      >
                        <v-radio-group disabled class="radio-group">
                          <v-radio 
                            :value="option.id" 
                            color="success"
                            disabled
                          >
                            <template v-slot:label>
                              <span>{{ option.text }}</span>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
  
              <!-- Open Question -->
              <v-textarea
                v-if="question.type === 'open'"
                label="Respuesta de desarrollo"
                disabled
                outlined
                rows="3"
              ></v-textarea>
            </v-card-text>
          </v-card>
        </template>
      </v-card>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        questions: [],
        loading: true
      };
    },
    methods: {
      async loadQuestions() {
        try {
          const response = await axios.get('/questionHabitos');
          this.questions = response.data.questionsBySection[0];
          this.loading = false;
        } catch (error) {
          console.error('Error cargando preguntas de hábitos:', error);
          this.$swal('Error', 'No se pudieron cargar las preguntas', 'error');
        }
      }
    },
    async created() {
      await this.loadQuestions();
    }
  };
  </script>